import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { MenuCategoryType } from '../../utils/common/types';

type State = {
  data: Array<[number, MenuCategoryType]>;
};

type Actions = {
  add: (toolCategory: number, categoryType: MenuCategoryType) => void;
};

const initialState = {
  data: [],
};

export const useRecentGeneratedTools = create<State & Actions>()(
  persist(
    (set, get) => ({
      ...initialState,
      add: (toolId, categoryId) => {
        set(() => ({
          data: [[toolId, categoryId], ...get().data.filter((tuple) => tuple[0] !== toolId)],
        }));
      },
    }),
    { name: 'recent-generated-tools' },
  ),
);
